import { createTheme } from "@mui/material/styles";

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#3f51b5",
    },
    secondary: {
      main: "#262626",
    },
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    text: {
      primary: "#374151",
      secondary: "#374151",
    },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#3f51b5",
    },
    secondary: {
      main: "#ffffff",
    },
    background: {
      default: "#262626",
      paper: "#262626",
    },
    text: {
      primary: "#d1d5db",
      secondary: "#d1d5db",
    },
  },
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          // Farbe des Labels im fokussierten Zustand erzwingen
          "&.Mui-focused": {
            color: "#ffffff",
          },
        },
      },
    },
    // Falls du auch den Text in der Border meinst, wenn er dort "steht" (shrink)
    MuiFormLabel: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#ffffff",
          },
        },
      },
    },
  },
});